var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.24 65H1V1H33V16.4733",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 58.1865H29.24",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2998 48.4532V31.9265H50.1932V48.4532H61.2998Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2475 48.46H50.2275L50.2275 18.0333L26.2475 18.0333L26.2475 48.46Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4933 20.7732V16.4732C44.4933 13.2999 41.92 10.7266 38.7467 10.7266C35.5733 10.7266 33 13.2999 33 16.4732V20.7732",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4938 22.8797C45.0755 22.8797 45.5471 22.4082 45.5471 21.8264C45.5471 21.2447 45.0755 20.7731 44.4938 20.7731C43.912 20.7731 43.4404 21.2447 43.4404 21.8264C43.4404 22.4082 43.912 22.8797 44.4938 22.8797Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0006 22.8797C33.5823 22.8797 34.0539 22.4082 34.0539 21.8264C34.0539 21.2447 33.5823 20.7731 33.0006 20.7731C32.4189 20.7731 31.9473 21.2447 31.9473 21.8264C31.9473 22.4082 32.4189 22.8797 33.0006 22.8797Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4938 32.2266H32.9805V42.7399H43.4938V32.2266Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4004 36.7667V34.64H37.5204",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3672 36.7667V34.64H41.4939",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4004 40.7333V38.6133H37.5204",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05371 18.0732H10.687C13.047 18.0732 15.1604 19.5532 15.9604 21.7799L26.6737 51.5466C27.4737 53.7732 29.5804 55.2532 31.9471 55.2532H60.0871",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2407 64.9998C31.1221 64.9998 32.6473 63.4746 32.6473 61.5932C32.6473 59.7117 31.1221 58.1865 29.2407 58.1865C27.3592 58.1865 25.834 59.7117 25.834 61.5932C25.834 63.4746 27.3592 64.9998 29.2407 64.9998Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6469 64.9998C57.5284 64.9998 59.0536 63.4746 59.0536 61.5932C59.0536 59.7117 57.5284 58.1865 55.6469 58.1865C53.7655 58.1865 52.2402 59.7117 52.2402 61.5932C52.2402 63.4746 53.7655 64.9998 55.6469 64.9998Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.627 25.96H65.0003L61.5003 48.4533H25.207",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33 7.81348H1",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3337 61.5935H14.667",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3337 4.40662H14.667",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05371 47.5332H20.407",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05371 41.3467H17.6137",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05371 35.1533H14.827",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopMobile);
export default __webpack_public_path__ + "static/media/shop_mobile.511dcb45ad7525bba40e512d9acb47f3.svg";
export { ForwardRef as ReactComponent };